import { useCallback } from 'react';

/**
 * Chạy một thao tác GHI rồi tải lại danh sách; trả `true` nếu thành công.
 *
 * Bốn màn từng chép lại đúng khối này cho mỗi nút (thêm / sửa / xoá / gán proxy):
 *
 * ```ts
 * try { await service.x(); list.reload(); return true; } catch { return false; }
 * ```
 *
 * Nuốt lỗi là CỐ Ý — interceptor axios đã bắn toast rồi, ném thêm ở đây chỉ tạo
 * unhandled rejection. Cái caller cần biết chỉ là "có đóng popup không".
 */
export function useMutation(onSuccess: () => void) {
  return useCallback(
    async <T>(run: () => Promise<T>): Promise<boolean> => {
      try {
        await run();
        onSuccess();
        return true;
      } catch {
        return false;
      }
    },
    [onSuccess],
  );
}
